import { defineComponent as _defineComponent } from 'vue'
import AdAccount from '@/views/Automation/CampaignCreatorV2/steps/CampaignCards/AdAccount.ts.vue';
import AdvantageCampaignBudget from '@/views/Automation/CampaignCreatorV2/steps/CampaignCards/AdvantageCampaignBudget.ts.vue';
import CampaignDetails from '@/views/Automation/CampaignCreatorV2/steps/CampaignCards/CampaignDetails.ts.vue';
import CampaignName from '@/views/Automation/CampaignCreatorV2/steps/CampaignCards/CampaignName.ts.vue';
import SpecialAdCategories from '@/views/Automation/CampaignCreatorV2/steps/CampaignCards/SpecialAdCategories.ts.vue';
import 'driver.js/dist/driver.css';

export default /*#__PURE__*/_defineComponent({
  __name: 'CampaignTab.ts',
  setup(__props) {


return { __sfc: true,AdAccount, AdvantageCampaignBudget, CampaignDetails, CampaignName, SpecialAdCategories }
}

})